(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const detailsMenus = document.querySelectorAll('header-menu details.mega-menu');

detailsMenus.forEach(details => {
  let closeTimeout;
  const summary = details.querySelector('summary');

  details.addEventListener('mouseenter', () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    details.setAttribute('open', '');
  });

  details.addEventListener('mouseleave', () => {
    closeTimeout = setTimeout(() => {
      details.removeAttribute('open');
    }, 300); 
  });

  if (summary) {
    summary.addEventListener('click', event => {
      const url = summary.dataset.url;
      if (!url) return;

      // Alleen op desktop direct naar de categorie gaan
      const isDesktop = window.matchMedia('(hover: hover)').matches && window.innerWidth > 1024;

      if (isDesktop) {
        event.preventDefault();
        window.location.href = url;
      }
      // Op mobiel blijft het standaard gedrag van summary voor uitklappen
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
